import { Component, inject, OnInit } from '@angular/core';
import { AuthService, ToastService } from 'libs/core/src/public-api';
import { FormGroup } from '@angular/forms';
import {
  FormFactoryComponent,
  FormFactoryService,
} from 'ngx-dynamic-forms-factory';
import { LoginFieldsService } from '../../services/login-fields.service';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { ButtonComponent } from 'libs/ui/src/public-api';

@Component({
  selector: 'lib-register',
  imports: [FormFactoryComponent, TranslateModule, RouterLink, ButtonComponent],
  templateUrl: './register.component.html',
})
export class RegisterComponent implements OnInit {
  authService = inject(AuthService);

  form!: FormGroup;
  formFactory = inject(FormFactoryService);
  fieldsService = inject(LoginFieldsService);
  toastService = inject(ToastService);

  ngOnInit(): void {
    this.form = this.formFactory.createForm(this.fieldsService.registerFields);
  }

  onRegister() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.authService.register(this.form.getRawValue());
  }
}
